function throttleRAF(callback) {
    let ticking = false;
    return function (...args) {
      if (!ticking) {
        requestAnimationFrame(() => {
          callback(...args);
          ticking = false;
        });
        ticking = true;
      }
    };
  }
  
  // Add debounce helper for iOS momentum scrolling
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  
  document.addEventListener("DOMContentLoaded", () => {
    const mobileMediaQuery = window.matchMedia("(max-width: 900px)");
    let stickyEnabled = false;
    let isAnimating = false;
    let isVisible = false;
    let isScrollingAbove = false;
    let lastScrollY = 0;
    let buttonOffset, buttonHeight, scrollHandler;
    let lastViewportHeight = 0;
    let initialButtonOffset = null;
  
    const productForm = document.querySelector(".product-info__block-list .shopify-product-form");
    if (!productForm) return;
  
    const placeholder = document.createElement("div");
    placeholder.style.display = "none";
    productForm.parentNode.insertBefore(placeholder, productForm);
  
    function updatePlaceholder() {
      if (isVisible) {
        placeholder.style.display = "block";
        placeholder.style.height = `${buttonHeight}px`;
      } else {
        placeholder.style.display = "none";
      }
    }
  
    function updateButtonAttributes(buyButton, shouldBeSticky) {
      if (!buyButton) return;
  
      if (shouldBeSticky) {
        if (buyButton.hasAttribute("data-quickbuy-trigger")) {
          const quickbuyValue = buyButton.getAttribute("data-quickbuy-trigger");
          const hasVariantParam = new URLSearchParams(window.location.search).has("variant");
  
          if (quickbuyValue && !hasVariantParam) {
            buyButton.removeAttribute("type");
            buyButton.setAttribute("aria-controls", quickbuyValue);
          }
        }
      } else {
        buyButton.setAttribute("type", "submit");
        buyButton.removeAttribute("aria-controls");
      }
    }
  
    function calculateInitialOffset() {
      const rect = productForm.getBoundingClientRect();
      // Get the initial offset without being affected by scroll
      return rect.top + window.pageYOffset;
    }
  
    function updateMeasurements() {
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const rect = productForm.getBoundingClientRect();
      
      // Only update buttonOffset if it hasn't been set or on significant layout changes
      if (!initialButtonOffset || Math.abs(lastViewportHeight - viewportHeight) > 100) {
        initialButtonOffset = calculateInitialOffset();
        buttonOffset = initialButtonOffset;
      }
      
      buttonHeight = rect.height;
      lastViewportHeight = viewportHeight;
      
      console.log('Measurements updated:', {
        initialButtonOffset,
        buttonHeight,
        viewportHeight,
        documentHeight: document.documentElement.scrollHeight
      });
      updatePlaceholder();
    }
  
    function checkInitialVisibility() {
      // Update measurements first to ensure accurate positioning
      updateMeasurements();
      
      // Always show sticky ATC on initial page load for mobile devices
      // This ensures users always see the add-to-cart button, even on large mobile screens
      isVisible = true;
      isAnimating = true;
      requestAnimationFrame(() => {
        updatePlaceholder();
        animateFormToSticky();
      });
    }
  
    function updateSticky() {
      if (isAnimating) return;
  
      const scrollY = window.pageYOffset || window.scrollY;
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const bottomScreenPos = scrollY + viewportHeight;
      const wasScrollingAbove = isScrollingAbove;
      
      // Simple scroll position checks like the old version
      if (bottomScreenPos + 40 <= buttonOffset) {
        // Scrolling above the button
        if (!isScrollingAbove && !isVisible) {
          isScrollingAbove = true;
          isAnimating = true;
          isVisible = true;
          requestAnimationFrame(() => {
            updatePlaceholder();
            animateFormToSticky();
          });
        }
      } else {
        isScrollingAbove = false;
        
        // Handle transition from scrolling above to below
        if (wasScrollingAbove && !isScrollingAbove && isVisible) {
          isAnimating = true;
          isVisible = false;
          requestAnimationFrame(() => {
            animateFormToStatic();
          });
        }
        
        // Normal scroll triggering
        if (!isScrollingAbove) {
          if (scrollY - 40 >= buttonOffset && !isVisible) {
            isAnimating = true;
            isVisible = true;
            requestAnimationFrame(() => {
              updatePlaceholder();
              animateFormToSticky();
            });
          } else if (scrollY - 40 < buttonOffset && isVisible) {
            isAnimating = true;
            isVisible = false;
            requestAnimationFrame(() => {
              animateFormToStatic();
            });
          }
        }
      }
    }
  
    function animateFormToSticky() {
      productForm.classList.remove("fade-in-prepare", "fade-in");
      productForm.style.opacity = "";
      productForm.style.visibility = "";

      if (!productForm.classList.contains("fixed-atc")) {
        productForm.classList.add("fixed-atc");
        updateButtonAttributes(productForm.querySelector(".buy-buttons__add-to-cart"), true);
      }

      void productForm.offsetWidth; // Force reflow

      requestAnimationFrame(() => {
        setTimeout(() => {
          if (!productForm.classList.contains("slide-up")) {
            productForm.classList.add("slide-up");
          }
          isAnimating = false;
        }, 50);
      });
    }
  
    function animateFormToStatic() {
        updateButtonAttributes(productForm.querySelector(".buy-buttons__add-to-cart"), false);
        productForm.classList.remove("slide-up");
      
        requestAnimationFrame(() => {
          
          setTimeout(() => {
            productForm.classList.add("fade-in-prepare");
          }, 100);
          setTimeout(() => {
            productForm.classList.remove("fixed-atc");
            requestAnimationFrame(() => {
              productForm.classList.add("fade-in");
              updatePlaceholder();
              setTimeout(() => {
                isAnimating = false;
              }, 300);
            });
          }, 300);
        });
      }
  
    function initializeSticky() {
      if (!stickyEnabled) {
        // Set initial offset once during initialization
        initialButtonOffset = calculateInitialOffset();
        buttonOffset = initialButtonOffset;
        
        // Check initial visibility before setting up scroll handlers
        checkInitialVisibility();
        
        updateMeasurements();
        
        // Use a combination of throttle and RAF for smoother performance
        const handleScroll = throttle(() => {
          requestAnimationFrame(updateSticky);
        }, 100); // Reduced from 300ms for more responsiveness while maintaining performance
  
        scrollHandler = handleScroll;
        window.addEventListener("scroll", scrollHandler, { passive: true });
        
        // Only update measurements on significant viewport changes
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', throttleRAF(() => {
            const newHeight = window.visualViewport.height;
            if (Math.abs(lastViewportHeight - newHeight) > 100) {
              updateMeasurements();
            }
          }), { passive: true });
        }
        
        // Update measurements when address bar likely changes
        let lastScrollTop = window.pageYOffset;
        const checkAddressBar = throttleRAF(() => {
          const currentScroll = window.pageYOffset;
          // Address bar likely changed if scroll near top/bottom
          if (currentScroll < 100 || 
              (window.innerHeight + currentScroll) >= document.documentElement.scrollHeight - 100) {
            updateMeasurements();
          }
          lastScrollTop = currentScroll;
        });
  
        // Add touch event listeners for more responsive iOS handling
        let touchStartY = 0;
        productForm.addEventListener('touchstart', (e) => {
          touchStartY = e.touches[0].clientY;
        }, { passive: true });
  
        productForm.addEventListener('touchmove', (e) => {
          const touchY = e.touches[0].clientY;
          const diff = touchStartY - touchY;
          
          if (Math.abs(diff) > 10) {
            updateSticky();
          }
        }, { passive: true });
  
        window.addEventListener('scroll', checkAddressBar, { passive: true });
        stickyEnabled = true;
      }
    }
  
    function destroySticky() {
      if (stickyEnabled) {
        window.removeEventListener("scroll", scrollHandler);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('scroll', throttleRAF(updateMeasurements));
          window.visualViewport.removeEventListener('resize', throttleRAF(updateMeasurements));
        }
        window.removeEventListener("resize", throttleRAF(updateMeasurements));
        productForm.classList.remove("fixed-atc", "slide-up", "fade-in-prepare", "fade-in");
        productForm.style.opacity = "";
        productForm.style.visibility = "";
        placeholder.style.display = "none";
        isVisible = false;
        isAnimating = false;
        stickyEnabled = false;
      }
    }
  
    function handleMobileChange(e) {
      if (e.matches) {
        initializeSticky();
      } else {
        destroySticky();
      }
    }
  
    handleMobileChange(mobileMediaQuery);
    mobileMediaQuery.addListener(handleMobileChange);
  });
  
  // Add back the original throttle function which worked well
  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    }
  }
  